export default function GetDateFromISOString(isoString: string) {
  const date = new Date(isoString);

  // Convert back to an ISO string and split at the "T"
  const parts = date.toISOString().split('T');

  // Return the date part
  return parts[0];
}
